import { Controller } from "react-hook-form";
import styled from "styled-components";
import { Pmb, P } from "./Typography";
import { forwardRef, useState } from "react";
import { ErrorMessage } from '@hookform/error-message';
import theme from "../common/theme";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Row from "./Row";
import { ButtonBase } from "./Buttons";

const Input = styled.input`
    flex: 1;
    outline: none;
    padding: 1rem;
    font-size: 1rem;
    background: ${theme.palette.light};
    border: 1px solid ${theme.palette.light};
    font-family: "Roboto Condensed";

    &::placeholder {
        font-family: "Roboto Condensed";
        color: ${theme.palette.dark};
        font-size: 14px;
    }
`

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    // margin: 1rem 0;
`

export const UncontrolledFormTextInput = forwardRef(({ errors, label, containerStyle, locationId, ...rest }, ref) => {
    const [type, setType] = useState("password");
    return (
        <Container style={containerStyle}>
            {label && <Pmb style={{ marginBottom: '0.5rem' }}>{label}</Pmb>}
            <Row>
                <Input
                    size={1}
                    ref={ref}
                    type={type}
                    {...rest}
                />
                <ButtonBase style={{ flex: 0, padding: '1rem', color: 'black' }} onClick={(e) => {
                    e.preventDefault();
                    setType(s => type === "password" ? "text" : "password")
                }} title="Show password">
                    {type === "password" ? <FaEye size="1.25rem" /> : <FaEyeSlash size="1.25rem" />}
                </ButtonBase>
            </Row>
            {errors && <ErrorMessage
                errors={errors}
                name={rest.name}
                render={({ message }) => <P style={{ color: 'red' }}>{message}</P>}
            />}
        </Container>
    )
})

export default ({ name, control, rules, ...rest }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { ...fieldProps } }) => (
                <UncontrolledFormTextInput {...fieldProps} {...rest} />
            )}
        />
    );
};
